import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SelectListItem } from '../models/selectlistitem';
import { Observable, of } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AppVersionService {
  private baseUrl;

  constructor(
    protected http: HttpClient, 
    @Inject('BASE_URL') baseUrl: String)
  {
    this.baseUrl = baseUrl + 'api/appversion';
  }

  public getAppVersion(): Observable<any> {
    const header = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.get(this.baseUrl, { headers: header })
  }
}
